<div class="alert alert-success d-flex align-items-center" role="alert">
  <svg class="bi flex-shrink-0 me-2" width="24" height="24" role="img" aria-label="Danger:"><use xlink:href="#exclamation-triangle-fill"/></svg>
  <div>
    {{ message }}
  </div>
</div>
<div style="text-align: center;display:block; margin-bottom:  20px;">
  <button type="button" class="btn btn-primary" (click)="accept()">{{ btnOkText }}</button>
</div>